export default __webpack_public_path__ + "static/verdure-b40eacde88b312f1e2e2e44e525b2568.png";